import http, { getAuthConfig } from './http';

const BASE_URL = '/home';
const BASE_URL_LANDING_PAGE = '/home/landing_page';

const getHomeData = (callback) => {
  http
    .get(BASE_URL, getAuthConfig())
    .then((res) => {
      callback({ payload: res.data.payload, error: null });
    })
    .catch((error) => callback({ payload: null, error }));
};

const getLandingPageData = (callback) => {
  http
    .get(BASE_URL_LANDING_PAGE, getAuthConfig())
    .then((res) => {
      callback({ payload: res.data.payload, error: null });
    })
    .catch((error) => callback({ payload: null, error }));
};

export const SERVICE_HOME = { getHomeData, getLandingPageData };
